/* eslint-disable react/prop-types */
import { Box, Typography } from "@mui/material";
import React from "react";
// import * as Sentry from "@sentry/react";
import Modal from "../../../../components/common/Modal/Modal";
// import { debounce } from "../../../../utils/helper";
// import Button from "../../../../components/common/Button";
// import { CommonStyles } from "../../../../components/common/Button/commonButtonStyle";
// import Gohonzon from "../../../../services/api/gohonzon";
// import { AlertStatus } from "../../../../contants";

// eslint-disable-next-line no-unused-vars
function GohonzonInterview({
  open,
  onClose,
  // toast,
  // goBack,
  // memberInfo,
  // regionIds,
  // prepareBody,
  // values,
}) {
  // const submitInterviewModal = async () => {
  //   try {
  //     const body = prepareBody(values);

  //     await Gohonzon.submitInterViewByRegionSi(
  //       {
  //         ...body,
  //         interviewedBy: regionIds,
  //         formType: "APPLICATION",
  //         memberId: memberInfo.memberId,
  //         gohonzonType: memberInfo.gohonzonType,
  //       },
  //       memberInfo.id
  //     );
  //     toast.show("Interview Done", AlertStatus.SUCCESS);
  //     setTimeout(() => {
  //       goBack();
  //     }, 2000);
  //   } catch (err) {
  //     toast.show(err.message, AlertStatus.ERROR);
  //     Sentry.captureException(err);
  //   }
  // };

  return (
    <Modal open={open} onClose={onClose}>
      <div>
        {/* <Formik initialValues={{}} onSubmit={{}}>
          {() => (
            <form> */}
        <Box>
          <Typography
            style={{
              color: "#8C8C8C",
              fontSize: "20px ",
              fontWeight: "500",
            }}
          >
            Gohonzon Interview
          </Typography>
          <Box marginTop="24px" color="#183053" maxWidth="550px">
            <Typography fontWeight={500}>
              {`You can't submit this application. You have selected 'NO' as the answer for one or more questions.`}
            </Typography>
          </Box>
        </Box>
        {/* <div style={{ marginTop: "24px", display: "flex", gap: 5 }}>
                <Button
                  variant="contained"
                  style={CommonStyles.buttonStyle}
                  type="submit"
                  label="Submit"
                  onClick={handleSubmit}
                />
                <Button
                  variant="outlined"
                  style={{
                    ...CommonStyles.buttonStyle,
                    marginLeft: "20px",
                  }}
                  onClick={onClose}
                  label="CANCEL"
                />
              </div> */}
        {/* </form>
          )}
        </Formik> */}
      </div>
    </Modal>
  );
}

export default GohonzonInterview;
